import { render, staticRenderFns } from "./OrderHistoryTable.vue?vue&type=template&id=00ab5c7e&scoped=true&"
import script from "./OrderHistoryTable.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryTable.vue?vue&type=style&index=0&id=00ab5c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ab5c7e",
  null
  
)

export default component.exports